const isWindowUndefined = typeof window === 'undefined';

export function isServerSide() {
  return isWindowUndefined;
}

export function isClientSide() {
  return !isWindowUndefined;
}
